<template>
  <div class="swiper-container" :class="[!hasMore ? 'ct-large' : '']">
    <div class="swiper-wrapper">
      <slot name="item"></slot>
    </div>
    <div
      v-show="hasMore"
      class="swiper-button-prev button-nav button-nav--prev"
      :style="containerStyles"
    >
      <svg :style="arrowStyles"><use xlink:href="#chevron-left" /></svg>
    </div>
    <div
      v-show="hasMore"
      class="swiper-button-next button-nav button-nav--next"
      :style="containerStyles"
    >
      <svg :style="arrowStyles"><use xlink:href="#chevron-right" /></svg>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'

export default {
  name: 'swiper',
  data() {
    return {
      swiper: null,
      sizeItem: 0,
      totalItems: 0,
      hasMore: false
    }
  },
  props: {
    backgroundColor: {
      type: String,
      default: '#9ddda9',
    },
    arrowColor: {
      type: String,
      default: '#1d2822',
    },
  },
  watch: {
    sizeItem() {
      this.swiper = new Swiper('.swiper-container', {
        slidesPerView: 'auto',
        spaceBetween: 10,
        centeredSlides: true,
        breakpointsInverse: true,
        breakpoints: {
          // when window width is <= 920px
          920: {
            centeredSlides: false
          }
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
      })
    }
  },
  mounted() {
    this.totalItems = this.$slots.item.length

    if (this.totalItems) {
      this.sizeItem = this.$slots.item[0].elm.offsetWidth
    }

    this.checkIfHasMore()
    window.addEventListener('resize', this.onResize)
  },
  methods: {
    checkIfHasMore() {
      this.hasMore = (this.sizeItem * this.totalItems) >= this.$el.offsetWidth
    },
    onResize() {
      this.checkIfHasMore()
      this.swiper.virtual.update()
    },
  },
  computed: {
    containerStyles() {
      return {
        backgroundColor: this.backgroundColor || '#9ddda9',
      }
    },
    arrowStyles() {
      return {
        fill: this.arrowColor || '#1d2822',
        color: this.arrowColor || '#1d2822'
      }
    },
  },
}
</script>
